import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["fill"]


export default /*@__PURE__*/_defineComponent({
  __name: 'VerificationSvg',
  props: {
  width: {
    type: [String, Number],
    default: 37,
  },
  height: {
    type: [String, Number],
    default: 43,
  },
  fill: {
    type: String,
    default: 'currentColor',
  },
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _mergeProps(_ctx.$attrs, {
    width: __props.width,
    height: __props.height,
    viewBox: "0 0 37 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), [
    _createElementVNode("path", {
      d: "M36.2546 5.50994L19.2601 0.0981414C19.055 0.0327138 18.78 0 18.5049 0C18.2298 0 17.9547 0.0327138 17.7497 0.0981414L0.7552 5.50994C0.34009 5.6408 0 6.08945 0 6.50071V29.0452C0 29.4565 0.285076 29.9986 0.630167 30.2556L17.8697 42.8084C18.0448 42.9346 18.2698 43 18.4999 43C18.73 43 18.96 42.9346 19.1301 42.8084L36.3696 30.2556C36.7147 30.0033 36.9998 29.4611 36.9998 29.0452V6.50071C37.0098 6.08945 36.6697 5.64547 36.2546 5.50994ZM27.6323 13.4921L16.9995 27.1712C16.9247 27.2668 16.8269 27.3446 16.7139 27.3982C16.601 27.4518 16.476 27.4797 16.3493 27.4797C16.2226 27.4797 16.0977 27.4518 15.9847 27.3982C15.8717 27.3446 15.7739 27.2668 15.6992 27.1712L9.37748 19.0395C9.18743 18.7918 9.37748 18.4459 9.70257 18.4459H12.4633C12.7184 18.4459 12.9634 18.5628 13.1135 18.7544L16.3493 22.9137L23.8963 13.2024C24.0464 13.0108 24.2864 12.8939 24.5465 12.8939H27.3072C27.6323 12.8986 27.8224 13.2444 27.6323 13.4921Z",
      fill: __props.fill
    }, null, 8, _hoisted_2)
  ], 16, _hoisted_1))
}
}

})